import { colors, gradient } from "./global/colors";
import { fontSize } from "./global/fontsize";
import { margin, padding, rounded } from "./global/whitespace";
import { boxShadow, transition } from "./global/other";

const config = {
  colors,
  gradient,
  margin,
  padding,
  fontSize,
  borderRadius: rounded,
  screens: {
    MAX_WIDTH: 1440,
    MOBILE_WIDTH: 768,
  },
  boxShadow,
  transition,
};

export default config;
